import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/PublicLegalPage.module.css';
import PublicLegalFooter from '../components/PublicLegalFooter';

const PrivacyPolicyPage = () => (
  <div className={styles.container}>
    <div className={styles.content}>
      <h1 className={styles.title}>Privacy Policy</h1>
      <p className={styles.subtitle}>Last updated: July 24, 2026</p>

      <section className={styles.section}>
        <h2>Overview</h2>
        <p>
          LOTW League (&quot;we,&quot; &quot;us&quot;) operates the LOTW League web application at
          lotwleague.com. This policy describes how we collect, use, and protect information when you
          use our service.
        </p>
      </section>

      <section className={styles.section}>
        <h2>Information We Collect</h2>
        <ul>
          <li>Account information such as username, email, and password (stored securely)</li>
          <li>Optional profile information you choose to provide</li>
          <li>Optional mobile phone number if you enable SMS features</li>
          <li>League activity such as picks, locks, and game-related preferences</li>
          <li>Technical data such as IP address and browser type for security and operation</li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2>Mobile Phone Numbers &amp; SMS</h2>
        <p>
          If you choose to add a phone number, we use it only to deliver the SMS messages you request
          (verification codes, password reset codes, and optional pick reminders).
        </p>
        <p>
          <strong>
            We do not sell, rent, or share your mobile phone number or SMS opt-in data with third
            parties or affiliates for marketing or promotional purposes.
          </strong>
        </p>
        <p>
          SMS delivery is provided through our messaging provider (Twilio) solely to transmit messages
          on our behalf. See our <Link to="/sms-opt-in" className={styles.link}>SMS Opt-In</Link> page
          for consent and opt-out details.
        </p>
      </section>

      <section className={styles.section}>
        <h2>How We Use Information</h2>
        <ul>
          <li>Operate the league pick&apos;em application and display standings</li>
          <li>Authenticate users and secure accounts</li>
          <li>Send notifications you have opted into (Discord, email when available, SMS when enabled)</li>
          <li>Maintain league records and admin functions</li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2>Data Security</h2>
        <p>
          We use industry-standard practices to protect account data, including encrypted connections
          (HTTPS) and secure password storage. No method of transmission over the Internet is 100%
          secure, but we work to protect your information.
        </p>
      </section>

      <section className={styles.section}>
        <h2>Your Choices</h2>
        <ul>
          <li>You may update profile information in User Settings</li>
          <li>You may remove your phone number or disable SMS reminders at any time</li>
          <li>Contact your league administrator for account deletion requests</li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2>Changes</h2>
        <p>
          We may update this policy from time to time. Continued use of the service after changes
          constitutes acceptance of the updated policy.
        </p>
      </section>

      <PublicLegalFooter />
    </div>
  </div>
);

export default PrivacyPolicyPage;
